﻿/**
 * Represents the type of Active Adult communities filter that can be applied to search results.
 */
export default class ActiveAdultType {
  /**
   * Used on the Active Adult communities filter, when the user selects the '55+ Communities Only' option.
   * It's used to exclusively show communities that are 55+ (adult and age restricted).
   */
  static get OnlyShowActiveAdultCommunities() {
    return this.getInstance('only');
  }

  /**
   * Used on the Active Adult communities filter, when the user selects the 'Exclude 55+ Communities' option.
   * It's used to exclude communities that are 55+ (adult and age restricted).
   */
  static get ExcludeActiveAdultCommunities() {
    return this.getInstance('exclude');
  }

  /**
   * Used on the Active Adult communities filter, when the user selects the 'Show All Communities' option.
   * This is the default value, and displays any kind of communities in the search results page.
   */
  static get AnyCommunities() {
    return this.getInstance('any');
  }

  static fromKey(key) {
    const map = {
      only: ActiveAdultType.Only,
      exclude: ActiveAdultType.Exclude,
      any: ActiveAdultType.Any,
    };
    return map[key];
  }

  static getInstance(key) {
    if (!this.instances[key]) {
      this.instances[key] = new ActiveAdultType(key);
    }
    return this.instances[key];
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}

Object.defineProperty(ActiveAdultType, 'instances', { value: {} });
